module.exports = __webpack_public_path__ + "static/media/ic_hamburguermenu.2d39d4bd.svg";